import { DateTime } from 'luxon'

import { isDate, isNumber, isString } from 'lodash'

export function dateFilter(input: Date | string | number, format: string): string {

    let dateTime: DateTime = null;

    if(isDate(input)){
        dateTime = DateTime.fromJSDate(input);
    }
    else if(isString(input)){
        dateTime = DateTime.fromISO(input);
    }
    else if(isNumber(input)){
        dateTime = DateTime.fromMillis(input);
    }

    if(!dateTime){
        return null;
    }

    return dateTime.toFormat(format);
}